import axios from 'axios';

const getDataForYears = ( yearFrom, yearTo ) => {
  const url = "/api/liam-api.json";
  return axios.get(url)
}

export default getDataForYears;